var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1636 19.4719C-3.45942 21.3124 -4.51229 -0.931111 11.7987 0.661935C12.3291 0.71374 12.3931 1.51342 11.9137 1.74633C5.14806 5.03373 5.16328 14.8639 12.2797 18.4588C12.7358 18.6892 12.671 19.4121 12.1636 19.4719Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNightIcon);
export default __webpack_public_path__ + "static/media/night-icon.4d68ab5134e0eaa23ca945c76ebc1947.svg";
export { ForwardRef as ReactComponent };